module.exports = __webpack_public_path__ + "img/103.f4b056a6.jpg";